export default __webpack_public_path__ + "cdf68e3bb2480db61882548a879693ff.svg";